import { render, staticRenderFns } from "./contract.vue?vue&type=template&id=6bdf7f3c&scoped=true"
import script from "./contract.vue?vue&type=script&lang=js"
export * from "./contract.vue?vue&type=script&lang=js"
import style0 from "./contract.vue?vue&type=style&index=0&id=6bdf7f3c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdf7f3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\certbuyliantuo\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bdf7f3c')) {
      api.createRecord('6bdf7f3c', component.options)
    } else {
      api.reload('6bdf7f3c', component.options)
    }
    module.hot.accept("./contract.vue?vue&type=template&id=6bdf7f3c&scoped=true", function () {
      api.rerender('6bdf7f3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cost/component/contract.vue"
export default component.exports